module.exports = __webpack_public_path__ + "img/btn-show-menu.babefd11.svg";